import { ChakraProvider, Box } from "@chakra-ui/react";
import { useEffect } from "react";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	useLocation,
} from "react-router-dom";
import { theme } from "./theme";
import { Navbar } from "./components/Navbar";
import { Sidebar } from "./components/Sidebar";
import { HomePage } from "./pages/HomePage";
import { GettingStartedPage } from "./pages/GettingStartedPage";
import { SchedulePage } from "./pages/SchedulePage";
import { UsersAndRolesPage } from "./pages/UsersAndRolesPage";
import { ObjectsAndBlocksPage } from "./pages/ObjectsAndBlocksPage";
import { BrigadesPage } from "./pages/BrigadesPage";
import { SettingsPage } from "./pages/SettingsPage";
import { TroubleshootingPage } from "./pages/TroubleshootingPage";
import { WarehousePage } from "./pages/WarehousePage";
import { RoleScenariosPage } from "./pages/RoleScenariosPage";
import { ApiPage } from "./pages/ApiPage";
import { ApiAccessOrgPage } from "./pages/ApiAccessOrgPage";
import { ApiProductionPage } from "./pages/ApiProductionPage";
import { ApiWarehousePage } from "./pages/ApiWarehousePage";
import { ApiPlatformPage } from "./pages/ApiPlatformPage";

function ScrollToTop() {
	const { pathname } = useLocation();
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);
	return null;
}

function App() {
	return (
		<ChakraProvider theme={theme}>
			<Router>
				<Box minH="100vh" bg="gray.50">
					<ScrollToTop />
					<Navbar />
					<Box display="flex" flexDirection={{ base: "column", lg: "row" }}>
						<Sidebar />
						<Box
							as="main"
							id="main-content"
							minW={0}
							flex="1"
							p={{ base: 4, md: 6 }}
							ml={{ base: 0, lg: 72 }}
						>
							<Routes>
								<Route path="/" element={<HomePage />} />
								<Route
									path="/getting-started"
									element={<GettingStartedPage />}
								/>
								<Route path="/schedule" element={<SchedulePage />} />
								<Route
									path="/users-and-roles"
									element={<UsersAndRolesPage />}
								/>
								<Route
									path="/objects-and-blocks"
									element={<ObjectsAndBlocksPage />}
								/>
								<Route path="/brigades" element={<BrigadesPage />} />
								<Route path="/settings" element={<SettingsPage />} />
								<Route path="/warehouse" element={<WarehousePage />} />
								<Route path="/api" element={<ApiPage />} />
								<Route path="/api/access-org" element={<ApiAccessOrgPage />} />
								<Route path="/api/production" element={<ApiProductionPage />} />
								<Route path="/api/warehouse" element={<ApiWarehousePage />} />
								<Route path="/api/platform" element={<ApiPlatformPage />} />
								<Route path="/role-scenarios" element={<RoleScenariosPage />} />
								<Route
									path="/troubleshooting"
									element={<TroubleshootingPage />}
								/>
							</Routes>
						</Box>
					</Box>
				</Box>
			</Router>
		</ChakraProvider>
	);
}

export default App;
